 import React from "react"
import PropTypes from 'prop-types'

import SelectGenericNew from "../../../../../../gd-ui/select-generic-new/select-generic-new"
import {
    VALIDATION_AFTER_DAY_DELTA,
    VALIDATION_BEFORE_DAY_DELTA,
    VALIDATION_CHANGED, VALIDATION_EMPTY,
    VALIDATION_LABELS, VALIDATION_NOT_EMPTY
} from "../../../../../../model2/automation/lib/custom-field-validation"
 import {FieldAutomationTriggerFormProps} from "../../../../../render/automation-trigger-form";
 import {pastAndFutureOptions} from "../../../../../../gd/const/automation/days-options";

const options = _.map([
    VALIDATION_CHANGED,
    VALIDATION_EMPTY,
    VALIDATION_NOT_EMPTY,
    VALIDATION_BEFORE_DAY_DELTA,
    VALIDATION_AFTER_DAY_DELTA,
], value=> {
    // @ts-ignore
    return { value: value, label: _.get(VALIDATION_LABELS, value) }
})

const debug = false
// const debug = "DateTriggerForm"

export default class FieldDate_AutomationTriggerForm extends React.Component<any,any> {

    public beforeOptions        : any
    public afterOptions         : any

    // static propTypes = {
    //     config          : PropTypes.object,
    //
    //     options         : PropTypes.array,
    //
    //     onChangeCallback: PropTypes.func,
    // }

    constructor(props:FieldAutomationTriggerFormProps) {
        super(props)

        this.state = {
            validationType  : _.get(props.config, 'validationType', VALIDATION_CHANGED),
            value           : _.get(props.config, 'value', null)
        }

        this.beforeOptions  = _.filter(pastAndFutureOptions, o=>o.value <= 0)
        this.afterOptions   = _.filter(pastAndFutureOptions, o=>o.value >= 0)
    }

    onChangeValidationType = (option:any) => {
        const validationType = option.value

        this.setState({
            validationType,
            value: [VALIDATION_BEFORE_DAY_DELTA, VALIDATION_AFTER_DAY_DELTA].includes(validationType) ? 0 : null
        }, ()=>{
            this.props.onChangeCallback({validationType, value: this.state.value})
        })
    }

    onChangeValue = (option:any) => {
        const value = option.value

        this.setState({
            value
        }, ()=>{
            this.props.onChangeCallback({value})
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state, options)

        return (
            <React.Fragment>
                <div className="flex-row-left-top">
                    <div className="label w-100">Trigger when</div>
                    <SelectGenericNew className                     = "selector w-180"
                                      options                       = {options}
                                      value                         = {this.state.validationType}
                                      popoverScrollContainerClasses = "max-h-200 max-w-300"
                                      disabled                      = {this.props.config.disabled}
                                      onChange                      = {this.onChangeValidationType}/>
                </div>

                {[VALIDATION_BEFORE_DAY_DELTA].includes(this.state.validationType) &&
                    <div className="flex-row-left-top m-t-10">
                        <div className="label w-100">Date</div>
                        <SelectGenericNew className                     = "selector w-180"
                                          options                       = {this.beforeOptions}
                                          value                         = {this.state.value}
                                          popoverScrollContainerClasses = "max-h-200"
                                          scrollToSelected              = {true}
                                          disabled                      = {this.props.config.disabled}
                                          onChange                      = {this.onChangeValue}/>
                    </div>}

                {[VALIDATION_AFTER_DAY_DELTA].includes(this.state.validationType) &&
                    <div className="flex-row-left-top m-t-10">
                        <div className="label w-100">Date</div>
                        <SelectGenericNew className                     = "selector w-180"
                                          options                       = {this.afterOptions}
                                          value                         = {this.state.value}
                                          popoverScrollContainerClasses = "max-h-200"
                                          scrollToSelected              = {true}
                                          disabled                      = {this.props.config.disabled}
                                          onChange                      = {this.onChangeValue}/>
                    </div>}
            </React.Fragment>
        )
    }
}
